export default __webpack_public_path__ + "static/propertymanagement-customer-feedback-commonroom-pressnxpress-89e75d716923a5ebdfa482adf1bede61.jpg";